import BaseAPI from './BaseAPI'

export default class SwaggerAPI extends BaseAPI {
  static getSwaggers(groupId) {
    return this.execute('get', `/groups/${groupId}/swaggers`)
  }

  static getSwagger(groupId, swaggerId) {
    return this.execute('get', `/groups/${groupId}/swaggers/${swaggerId}`)
  }

  static createSwagger(groupId, data) {
    return this.execute('post', `/groups/${groupId}/swaggers`, data)
  }

  static updateSwagger(groupId, swaggerId, data) {
    return this.execute('patch', `/groups/${groupId}/swaggers/${swaggerId}`, data)
  }

  static deleteSwagger(groupId, swaggerId) {
    return this.execute('delete', `/groups/${groupId}/swaggers/${swaggerId}`)
  }

  static saveSwagger(groupId, swaggerId, data) {
    return this.execute('post', `/groups/${groupId}/swaggers/${swaggerId}/versions`, data)
  }

  static deleteGroup(groupId) {
    return this.execute('delete', `/groups/${groupId}`)
  }

  static downloadSwaggerAsJson(groupId, swaggerId) {
    return this.execute('get', `/groups/${groupId}/swaggers/${swaggerId}.json`)
  }

  static downloadSwaggerAsYaml(groupId, swaggerId) {
    return this.execute('get', `/groups/${groupId}/swaggers/${swaggerId}.yaml`)
  }

  static getSwaggerVersions(groupId, swaggerId) {
    return this.execute('get', `/groups/${groupId}/swaggers/${swaggerId}/versions`);
  }

  static getSwaggerVersion(groupId, swaggerId, version) {
    return this.execute('get', `/groups/${groupId}/swaggers/${swaggerId}/versions/${version}`);
  }
}



// WEBPACK FOOTER //
// ./src/api/SwaggerAPI.js